import { ThemeConfig } from '../../../themeConfig';

const config: ThemeConfig[] = [{
    name: 'echo-spacingHeaderTop',
    label: 'Header top spacing',
    type: 'size',
    minValue: 16,
    maxValue: 128,
    defaultValue: 35,
    unit: 'px',
},{
    name: 'echo-fontSizeHeaderTitle',
    label: 'Header title font size',
    type: 'size',
    minValue: 8,
    maxValue: 64,
    defaultValue: 22,
    unit: 'px',
},{
    name: 'echo-fontSizeHeaderBody',
    label: 'Header body font size',
    type: 'size',
    minValue: 8,
    maxValue: 64,
    defaultValue: 17,
    unit: 'px',
}, {
    name: 'echo-tableFontSize',
    label: 'Base font size',
    type: 'size',
    minValue: 8,
    maxValue: 32,
    defaultValue: 14,
    unit: 'px',
},{
    name: 'echo-spacingPricedItems',
    label: 'Base spacing',
    type: 'size',
    minValue: 0,
    maxValue: 32,
    defaultValue: 3.5,
    unit: 'px',
}, {
    name: 'echo-headerBackgroundColor',
    label: 'Table background color',
    type: 'color',
    defaultValue: '#494949',
}, {
    name: 'echo-bodyBackgroundColor',
    label: 'Header background color',
    type: 'color',
    defaultValue: '#FFFFFF',
}, {
    name: 'echo-borderColor',
    label: 'Border color',
    type: 'color',
    defaultValue: '#494949',
}, {
    name: 'echo-textColor',
    label: 'Text color light',
    type: 'color',
    defaultValue: '#FFFFFF',
}, {
    name: 'echo-textColorDark',
    label: 'Text color dark',
    type: 'color',
    defaultValue: '#000000',
},
];

export default config;
